import React from 'react';

import { Inline, Text } from '@atlaskit/primitives/compiled';

import type { PreviewPanelTitleProps } from './types';

export const PreviewPanelTitle = ({ title, icon }: PreviewPanelTitleProps) => {
	return (
		<Inline space="space.100" alignBlock="center">
			{icon}
			<Text weight="bold" maxLines={1}>
				{title}
			</Text>
		</Inline>
	);
};
